import { DefaultTheme } from 'styled-components/macro';
import { common } from './common';

export const acerta: DefaultTheme = Object.assign(
  { ...common },
  {
    // Cafeteria palette
    palette_blue_100: '#366BAB',
    palette_blue_5: '#90D0EE',
    palette_blue_0: '#90D0EE',

    // Primary palette
    palette_primary_125: '#E8318A',
    palette_primary_100: '#E8318A'
  }
);
